import React from 'react';
import { compose, lifecycle, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';

const styles = {
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  },
  userImage: {
    width: '100px',
    height: '100px',
    margin: '5px',
    float: 'left'
  },
  tag: {
    margin: '0px 10px 0px 0px',
    backgroundColor: '#fee'
  },
  anniversary: {
    margin: '0px 10px 0px 0px'
  },
  marginBottom12: {
    marginBottom: '12px'
  }
};

const enhance = compose(
  withState('haveRegistrationId', 'setHaveRegistrationId', 0),
  lifecycle({
    componentDidMount() {
      if (this.props.detail.paymentGroupId) {
        if (this.props.detail.groupRegistrationId) {
          this.props.setHaveRegistrationId(1);
        } else {
          this.props.setHaveRegistrationId(0);
        }
      } else if (this.props.detail.registrationId) {
        this.props.setHaveRegistrationId(1);
      } else {
        this.props.setHaveRegistrationId(0);
      }
    }
  })
);

const ShopTable = enhance(({ classes, detail, roles, haveRegistrationId }) => {
  const enableShopBank = detail.bankSwitchable;
  return (
    <Table className={classes.detailTable}>
      {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
        <TableRow>
          <TableCell className={classes.tableCellItem}>運営会社</TableCell>
          <TableCell className={classes.tableCellData}>
            {detail.groupName}
          </TableCell>
        </TableRow>
      )}
      <TableRow>
        <TableCell className={classes.tableCellItem}>店舗名</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.shopName}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>店舗名かな</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.shopNameKana}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>郵便番号</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.zipCode}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>住所</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.prefectures}
          {` `}
          {detail.city}
          {` `}
          {detail.address}
          {` `}
          {detail.building}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>店舗カテゴリー</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.shopCategories &&
            detail.shopCategories.length > 0 &&
            detail.shopCategories.map(item => {
              if (
                detail.shopCategoryId &&
                detail.shopCategoryId.toString() === item.id.toString()
              ) {
                return item.name;
              }
              return '';
            })}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>運営会社名</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.shopGroupName}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>ご担当者名</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.shopContactName}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>所属部署</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.department}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>
          電話番号（担当者）
        </TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.contactPhone}
        </TableCell>
      </TableRow>
      {!detail.paymentGroupId && (
        <>
          <TableRow>
            <TableCell className={classes.tableCellItem}>
              インボイス制度 適格事業者登録
            </TableCell>
            <TableCell className={classes.tableCellData}>
              {haveRegistrationId ? '登録済み' : '未登録'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>
              適格事業者登録番号
            </TableCell>
            <TableCell className={classes.tableCellData}>
              {// eslint-disable-next-line no-nested-ternary
              detail.paymentGroupId
                ? detail.groupRegistrationId
                : haveRegistrationId
                ? detail.registrationId
                : undefined}
            </TableCell>
          </TableRow>
        </>
      )}
      <TableRow>
        <TableCell className={classes.tableCellItem}>店舗電話番号</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.phone}
          {!roles.isShop && (
            <frameElement>
              {'('}
              {detail.showPhone ? `表示` : `非表示`}
              {')'}
            </frameElement>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>メールアドレス</TableCell>
        <TableCell className={classes.tableCellData}>{detail.email}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>店舗概要</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.introduction}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>営業時間</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.businessHours}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>定休日</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.holiday}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>価格帯</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.priceRange}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>最寄駅</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.nearestStation}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>アクセス</TableCell>
        <TableCell className={classes.tableCellData}>{detail.access}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>WebページURL</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.webPage}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>SNS</TableCell>
        <TableCell className={classes.tableCellData}>
          <div className={classes.margin}>
            <Grid container spacing={1} alignItems="flex-end">
              <Grid item>
                <CardMedia
                  component="img"
                  alt="Facebook"
                  height="24"
                  image="/images/icon_facebook.png"
                  title="Facebook"
                  className={classes.marginBottom12}
                />
              </Grid>
              <Grid item xs={12} sm container>
                <TableCell className={classes.tableCellData}>
                  {detail.snsFacebook}
                </TableCell>
              </Grid>
            </Grid>
            <Grid container spacing={1} alignItems="flex-end">
              <Grid item>
                <CardMedia
                  component="img"
                  alt="Twitter"
                  height="24"
                  image="/images/icon_twitter.png"
                  title="Twitter"
                  className={classes.marginBottom12}
                />
              </Grid>
              <Grid item xs={12} sm container>
                <TableCell className={classes.tableCellData}>
                  {detail.snsTwitter}
                </TableCell>
              </Grid>
            </Grid>
            <Grid container spacing={1} alignItems="flex-end">
              <Grid item>
                <CardMedia
                  component="img"
                  alt="Instagram"
                  height="24"
                  image="/images/icon_instagram.png"
                  title="Instagram"
                  className={classes.marginBottom12}
                />
              </Grid>
              <Grid item xs={12} sm container>
                <TableCell className={classes.tableCellData}>
                  {detail.snsInstagram}
                </TableCell>
              </Grid>
            </Grid>
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>座席</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.numberSit}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>禁煙/喫煙</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.smoking}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>駐車場</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.parking}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>
          店舗詳細表示制限
        </TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.stealthModeStr}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>誰でもごち制限</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.gochiRestrictionStr}
        </TableCell>
      </TableRow>
      {/* <TableRow>
        <TableCell className={classes.tableCellItem}>
          社食ごちめし現金授受の有無
        </TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.cashAllowed ? '受け付ける' : '受け付けない'}
        </TableCell>
      </TableRow> */}
      <TableRow>
        <TableCell className={classes.tableCellItem}>
          社食ごちめし金額指定チケット利用の有無
        </TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.shopDetail && detail.shopDetail.allowMenuPriceShashoku
            ? '利用する'
            : '利用しない'}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>タグ</TableCell>
        <TableCell className={classes.tableCellData}>
          <div>
            {detail.tags.map(tag => {
              return <span className={classes.tag}>{tag.tagName}</span>;
            })}
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>記念日</TableCell>
        <TableCell className={classes.tableCellData}>
          <div>
            {detail.shopAnniversaries.map(anniversary => {
              return (
                <div className={classes.anniversary}>
                  {anniversary.anniversary}
                  &nbsp;
                  {anniversary.message}
                </div>
              );
            })}
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>画像</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.images.map(image => {
            return (
              <Card className={classes.userImage}>
                <CardActionArea>
                  <CardMedia component="img" image={image.image} />
                </CardActionArea>
              </Card>
            );
          })}
        </TableCell>
      </TableRow>
      {enableShopBank && (
        <TableRow>
          <TableCell className={classes.tableCellItem}>入金管理</TableCell>
          <TableCell className={classes.tableCellData}>
            {detail.depositManageStr}
          </TableCell>
        </TableRow>
      )}
      {detail.depositManage === 'NONSELF' && enableShopBank && (
        <TableRow>
          <TableCell className={classes.tableCellItem}>銀行名</TableCell>
          <TableCell className={classes.tableCellData}>
            {detail.bankName}
          </TableCell>
        </TableRow>
      )}
      {detail.depositManage === 'NONSELF' && enableShopBank && (
        <TableRow>
          <TableCell className={classes.tableCellItem}>支店名</TableCell>
          <TableCell className={classes.tableCellData}>
            {detail.bankBranchName}
          </TableCell>
        </TableRow>
      )}
      {detail.depositManage === 'NONSELF' && enableShopBank && (
        <TableRow>
          <TableCell className={classes.tableCellItem}>口座種別</TableCell>
          <TableCell className={classes.tableCellData}>
            {detail.bankAccountTypeStr}
          </TableCell>
        </TableRow>
      )}
      {detail.depositManage === 'NONSELF' && enableShopBank && (
        <TableRow>
          <TableCell className={classes.tableCellItem}>口座番号</TableCell>
          <TableCell className={classes.tableCellData}>
            {detail.bankAccountNumber}
          </TableCell>
        </TableRow>
      )}
      {detail.depositManage === 'NONSELF' && enableShopBank && (
        <TableRow>
          <TableCell className={classes.tableCellItem}>口座名義</TableCell>
          <TableCell className={classes.tableCellData}>
            {detail.bankAccountHolder}
          </TableCell>
        </TableRow>
      )}
      <TableRow>
        <TableCell className={classes.tableCellItem}>登録日時</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.createdAt}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.tableCellItem}>更新日時</TableCell>
        <TableCell className={classes.tableCellData}>
          {detail.updatedAt}
        </TableCell>
      </TableRow>
    </Table>
  );
});

export default withStyles(styles)(ShopTable);
